import approvedEllipse from '@/assets/kyc/approved-ellipse.svg';
import approvedShield from '@/assets/kyc/approved-shield.png';
import { Medallion } from '@/components/features/Notifications/popups/Medallion';
import { PopupCta } from '@/components/features/Notifications/popups/PopupCta';
import { PopupShell } from '@/components/features/Notifications/popups/PopupShell';

export interface KycApprovedPanelProps {
  /** Backdrop / Escape dismiss — resolves the gate as `dismissed`. */
  onClose: () => void;
  /** "Let's Predict" tap — resolves the gate store's `approve()` (closes + resumes the interceptor's retry). */
  onApproved: () => void;
}

/**
 * "You're Verified!" — shown once the resolved identity status is APPROVED.
 * Reuses the ARC-111 pop-up design system (PopupShell/Medallion/PopupCta) —
 * same card, same responsive dialog/bottom-sheet split — instead of a bespoke
 * layout. Requires an explicit tap so approval is always a deliberate
 * "Let's Predict", never a silent auto-close out from under the player.
 */
export function KycApprovedPanel({ onClose, onApproved }: KycApprovedPanelProps) {
  return (
    <PopupShell open onClose={onClose} testId="kyc-approved-panel">
      <Medallion
        circleSrc={approvedEllipse}
        illustrationSrc={approvedShield}
        tone="positive"
        size={190}
        illustrationSize={149}
      />
      <div className="flex flex-col items-center gap-3">
        <h2 className="text-3xl font-semibold tracking-[-0.6px] text-ink">You&apos;re Verified!</h2>
        <p className="max-w-[328px] text-xl leading-[30px] text-ink">Your identity check passed markets are waiting</p>
      </div>
      <PopupCta label="Let's Predict" width={234} onClick={onApproved} testId="kyc-approved-cta" />
    </PopupShell>
  );
}
